import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { PlayerTypeV2Enum } from '@/enum/player-v2/PlayerTypeV2Enum';
import { BannerDto } from '@/models/banner/banner.interface';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/useIsMobile';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export interface BannerDialogProps {
  user: any;
  getBannersAction: () => void;
  banners: BannerDto[];
}

export const BannerDialog = ({ user, getBannersAction, banners }: BannerDialogProps) => {
  const [open, setOpen] = React.useState(false);
  const [img, setImg] = React.useState('');
  const [activeBannerId, setActiveBannerId] = React.useState<number | null>(null);
  const [bannerQueue, setBannerQueue] = React.useState<BannerDto[]>([]);
  const location = useLocation();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (user && ['/', '/sportsbook'].includes(location.pathname)) {
      showPopup();
    }
  }, [user, location.pathname]);

  useEffect(() => {
    getBannersAction();
  }, []);

  const showPopup = () => {
    if (!user || !user.player_type || !user.player_type.id || user.player_type.id !== PlayerTypeV2Enum.POSTUP) {
      return;
    }

    const hiddenBanners = JSON.parse(localStorage.getItem('hiddenBanners') || '{}');

    const activeBanners = banners.filter(banner => {
      return !hiddenBanners[banner.id];
    });

    if (activeBanners.length > 0) {
      setBannerQueue(activeBanners);
      setImg(isMobile ? activeBanners[0].image_mobile_url : activeBanners[0].image_desktop_url);
      setActiveBannerId(activeBanners[0].id);
      setTimeout(() => setOpen(true), 2000);
    }
  };

  const handleClose = () => {
    setOpen(false);

    const [, ...remaining] = bannerQueue;
    if (remaining.length > 0) {
      const nextBanner = remaining[0];
      setBannerQueue(remaining);
      setActiveBannerId(nextBanner.id);
      setImg(isMobile ? nextBanner.image_mobile_url : nextBanner.image_desktop_url);
      setTimeout(() => setOpen(true), 500);
    }
  };

  const dontShowAnymore = () => {
    if (activeBannerId) {
      const hiddenBanners = JSON.parse(localStorage.getItem('hiddenBanners') || '{}');

      localStorage.setItem('hiddenBanners', JSON.stringify({ ...hiddenBanners, [activeBannerId]: true }));
    }

    handleClose();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
      PaperProps={{
        style: {
          maxWidth: isMobile ? undefined : '1200px',
        },
      }}
    >
      <DialogContent>
        <img src={img} style={{ width: '100%', height: 'auto' }} onClick={handleClose} />
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center' }}>
        <Button onClick={dontShowAnymore} color='default' variant='outlined'>
          Don&apos;t Show Again
        </Button>
        <Button onClick={handleClose} color='secondary' variant='contained'>
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
};
